import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { SITE } from "@/lib/seo";

const TITLE = "Aviso Legal | Vibra Marketing";
const DESCRIPTION =
  "Aviso legal de Vibra Marketing S.L. (CIF B25913948): titular del sitio, condiciones de uso, propiedad intelectual y legislación aplicable.";
const URL = `${SITE.url}/aviso-legal`;

const breadcrumb = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Inicio", item: `${SITE.url}/` },
    { "@type": "ListItem", position: 2, name: "Aviso legal", item: URL },
  ],
};

const AvisoLegal = () => (
  <div className="min-h-screen bg-background">
    <Helmet>
      {/* Estilos .prose extraídos del CSS principal — solo se cargan en páginas de artículo */}
      <link rel="stylesheet" href="/prose.css" />
      <title>{TITLE}</title>
      <meta name="description" content={DESCRIPTION} />
      <link rel="canonical" href={URL} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={TITLE} />
      <meta property="og:description" content={DESCRIPTION} />
      <meta property="og:url" content={URL} />
      <meta property="og:image" content={SITE.ogImage} />
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
    </Helmet>
    <Header />
    <main className="pt-24 pb-20">
      <article className="container px-6 max-w-3xl mx-auto prose prose-neutral">
        <h1 className="font-display text-4xl md:text-5xl uppercase mb-8">Aviso legal</h1>

        <p className="text-muted-foreground">
          De conformidad con el artículo 10 de la Ley 34/2002, de 11 de julio,
          de Servicios de la Sociedad de la Información y de Comercio
          Electrónico (LSSI-CE), se informa de los siguientes datos del
          titular del sitio web.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-3">1. Datos del titular</h2>
        <ul className="space-y-1 text-muted-foreground">
          <li><strong className="text-foreground">Denominación social:</strong> Vibra Marketing S.L.</li>
          <li><strong className="text-foreground">CIF:</strong> B25913948</li>
          <li><strong className="text-foreground">Domicilio social:</strong> Calle Remolino 49B, 1ºE, 28710 El Molar (Madrid), España</li>
          <li><strong className="text-foreground">Email de contacto:</strong> <span dangerouslySetInnerHTML={{ __html: '<!--email_off--><a href="mailto:direccion@vibramarketing.es" class="text-primary">direccion@vibramarketing.es</a><!--/email_off-->' }} /></li>
          <li><strong className="text-foreground">Teléfono:</strong> +34 614 541 275</li>
          <li><strong className="text-foreground">Sitio web:</strong> {SITE.url}</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-3">2. Objeto del sitio</h2>
        <p className="text-muted-foreground">
          Vibra Marketing S.L. pone a disposición de los usuarios el presente
          sitio web con el objetivo de facilitar información sobre la sociedad,
          sus servicios de marketing digital, sus precios y los canales para
          contratar o solicitar información comercial.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-3">3. Condiciones de uso</h2>
        <p className="text-muted-foreground">
          El acceso y uso del sitio atribuye la condición de usuario e implica
          la aceptación plena de las condiciones recogidas en este aviso legal,
          en la política de privacidad y en la política de cookies. El usuario
          se compromete a utilizar el sitio de forma diligente, correcta y
          lícita, absteniéndose de cualquier uso que pueda dañar al titular,
          a otros usuarios o a terceros.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-3">4. Propiedad intelectual e industrial</h2>
        <p className="text-muted-foreground">
          Todos los contenidos del sitio (textos, fotografías, gráficos,
          imágenes, iconos, tecnología, software, enlaces, contenido
          audiovisual, diseño, código fuente y marcas) son propiedad de Vibra
          Marketing S.L. o de terceros que han autorizado su uso. Queda
          expresamente prohibida su reproducción, distribución, comunicación
          pública o transformación sin autorización expresa.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-3">5. Enlaces a terceros</h2>
        <p className="text-muted-foreground">
          El sitio puede contener enlaces a páginas de terceros sobre las que
          Vibra Marketing S.L. no ejerce control. Vibra no asume ninguna
          responsabilidad por los contenidos, servicios o políticas de dichos
          sitios.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-3">6. Responsabilidad</h2>
        <p className="text-muted-foreground">
          Vibra Marketing S.L. se reserva el derecho a modificar, suspender o
          interrumpir, total o parcialmente, el sitio web sin necesidad de
          previo aviso. No garantiza la inexistencia de errores en el acceso
          ni en los contenidos, si bien hará lo razonable para evitarlos o
          subsanarlos.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-3">7. Protección de datos y cookies</h2>
        <p className="text-muted-foreground">
          El tratamiento de los datos personales recogidos a través del sitio
          se rige por la{" "}
          <a href="/privacidad" className="text-primary">política de privacidad</a>
          {" "}y por la{" "}
          <a href="/cookies" className="text-primary">política de cookies</a>.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-3">8. Legislación aplicable y jurisdicción</h2>
        <p className="text-muted-foreground">
          El presente aviso legal se rige por la legislación española. Para
          la resolución de cualquier controversia derivada del acceso o uso
          del sitio, las partes se someten a los Juzgados y Tribunales de
          Madrid (España), con renuncia expresa a cualquier otro fuero que
          pudiera corresponderles.
        </p>
      </article>
    </main>
    <Footer />
  </div>
);

export default AvisoLegal;
